import { FC, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { AssetSource } from 'models'
import ChevronRight from 'ui/components/svg/ChevronRight'
import { SectionWrapper } from './assetDetailsPane.styles'
import AttributeSources from './AttributeSources'
import { sourceLabel } from '../utils/assetSources'

/* Enough rows to show the shape of the estate before the list needs a toggle. */
const COLLAPSED_ROWS = 3

interface Props {
  sources: AssetSource[]
}

/* Every product instance that reported this entity, named rather than reduced to a logo. */
const InstanceSection: FC<Props> = ({ sources }) => {
  const [expanded, setExpanded] = useState(false)

  if (!sources.length) return null

  const collapsible = sources.length > COLLAPSED_ROWS
  const visible = collapsible && !expanded ? sources.slice(0, COLLAPSED_ROWS) : sources

  return (
    <SectionWrapper>
      <Box className="section-header">
        <Typography className="section-label">Instance</Typography>

        {collapsible && (
          <Box
            component="button"
            type="button"
            className="section-badge is-toggle"
            aria-expanded={expanded}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'Show less' : 'Show more'}
            <Box component="span" className={`badge-chevron ${expanded ? 'is-open' : ''}`}>
              <ChevronRight />
            </Box>
          </Box>
        )}
      </Box>

      <Box className="instance-list">
        {visible.map((source) => (
          <Box key={source.instance} className="value-row">
            <Typography className="value-text">{sourceLabel(source)}</Typography>
            <AttributeSources sources={[source]} />
          </Box>
        ))}
      </Box>
    </SectionWrapper>
  )
}

export default InstanceSection
